import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "vue3-carousel/dist/carousel.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap";
import './assets/styles/main.scss';
import '@vuepic/vue-datepicker/dist/main.css';

// Use plugins
import api from './plugins/sdk.api';
import filter from './plugins/filters';
import theme from './plugins/theme';
import msg from './plugins/msg';
import globalComponents from './global.components';

const app = createApp(App);
globalComponents(app);
app.use(store);
app.use(api);
app.use(theme);
app.use(filter);
app.use(msg);
app.use(router({app}));
app.mount("#app");